import React from 'react'
import { Link, graphql } from 'gatsby'

import Layout from '../components/layout'

const ContentPageBrands = ({ data }) => (
  <Layout toggleTopNav={false}>
    <>
      <div className="container mt-3">
        <div className="row">
          <div className={`col-12 col-lg-6`}>
            <img src="/merken.jpeg" alt="Nanini" className="img-fluid" />
          </div>
          <div className={`col-12 col-lg-6`}>
            <h1 className="h1 mt-5 mb-5">Ontdek de schitterende wereld van Nanini</h1>
            <p>Al meer dan 40 jaar is Nanini een vaste waarde in Turnhout voor wie op zoek is naar dat perfecte juweel. Met een hart voor stijl en een oog voor kwaliteit, stellen wij met veel zorg een uitgebreid assortiment samen – voor elke stijl en voor elke gelegenheid.</p>
            <p>Of je nu houdt van verfijnd en tijdloos, of liever iets trendy en uitgesproken draagt: bij Nanini vind je het allemaal. Onze collecties voor dames, heren én kids omvatten een ruime keuze van geliefde merken zoals <b>Melano, Qudo, Ania Haie, Dyrberg/Kern, 24Kae, Murielle Perrotti, Zag, Muja Juma, Dotti Love, Day&Eve, Virginie, Atelier Louiza, Pavie, Ibu, Orage (ook voor kids!), Viventy trouwringen, Lisa Mona, Blush, Naiomy, Ti Sento, Swarovski, Pandora, Cluse, Michael Kors, Skagen, Fossil, Diesel, Armani Exchange, Gemini en Steel & Barnett</b>. Elk merk vertelt zijn eigen verhaal.</p>
            <p>Kom gerust langs en laat je verrassen door ons unieke aanbod.</p>
          </div>
        </div>
      </div>
    </>
  </Layout>
)

export default ContentPageBrands

